/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для подкатегорий на странице канцтоваров. Нужна для появления кнопки "Еще" внутри каждой подкатегории
   */
  app.CategoryWithoutItemsView = app.View.extend({
    el: '.categories-wrapper',
    events: {
      'mouseenter .category-menu-tile__item': 'showMoreLink',
      'mouseleave .category-menu-tile__item': 'moreLinkNotDisplay'
    },
    
    /**
     * Добавляет кнопку "Еще" при наведении
     */
    showMoreLink: function (event) {
      var $menuItem = $(event.currentTarget),
        $moreLink = $($menuItem.find('.more-link')),
        $menu = $moreLink.parent('.g-ul'),
        li = $menu.find('li');
      if ($menu.is(':visible')) {
        var left = $menu.offset().left,
          width = $menu.width(),
          offset = left + width,
          more = li.filter(function (index, item) {
            var liLeft = $(item).offset().left;
            return liLeft >= offset;
          });
        more.addClass('not_display');
        var qtyMore = more.length + 1,
          $replaceElem = $(li[li.length - qtyMore]);
        if (more.length > 0) {
          $replaceElem.addClass('not_display');
          $moreLink.removeClass('not_display').text('Еще ' + qtyMore + ' ›');
          $moreLink.insertBefore($replaceElem);
        }
      }
    },
    
    /**
     * Скрывает кнопку "Еще" и делает видимыми все элементы списка
     */
    moreLinkNotDisplay: function (event) {
      var $menuItem = $(event.currentTarget),
        $moreLink = $menuItem.find('.more-link'),
        $menu = $moreLink.parent('.g-ul'),
        li = $menu.find('li');
      li.removeClass('not_display');
      if (!$moreLink.hasClass('not_display')) {
        $moreLink.addClass('not_display');
      }
    }
  });
  
})(jQuery);

}.call(window));